(function ($) {
    jQuery('.jumplinks-nav').each(function () {
        var jumplinkSection = jQuery(this);

        var jumplinks = [];

        jQuery('.page-section').each(function () {
            var section = jQuery(this);
            if (section.data('jumplinkid')) {
                jumplinks.push({ 'id': section.prop('id'), 'name': section.data('jumplinkid') });
            }
        });

        if (jumplinks.length > 0) {
            var jumplinkContainer = jumplinkSection.find('.jumplinks').first();
            var mobileJumplinkContainer = jumplinkSection.find('.mobile-jumplinks ul').first();
            jumplinks.map(function (jumpLink) {
                var jumplinkHtml = jQuery('<a>').prop('href', '#' + jumpLink.id).addClass('grey-link').addClass('me-4').addClass('fw-600').text(jumpLink.name);
                jumplinkContainer.append(jumplinkHtml);

                var mobileJumplinkHtml = jQuery('<a>').prop('href', '#' + jumpLink.id).addClass('grey-link').addClass('me-4').addClass('fw-600').text(jumpLink.name);
                var jumplinkLi = jQuery('<li>').append(mobileJumplinkHtml);;
                mobileJumplinkContainer.append(jumplinkLi);
            });
        } else {
            jumplinkSection.hide();
        }
    });

    // jump links
    var page = $("html, body");

    if (jQuery(".jumplinks").length) {
        var $jumplinks = jQuery(".jumplinks a");

        jQuery(".jumplinks a, .mobile-jumplinks a").click(function (e) {
            e.preventDefault();

            var targetRef = (jQuery(this).attr("href") || "").trim();
            if (targetRef.length < 2 || targetRef.indexOf("#") != 0) return;

            var targetEl = jQuery(targetRef);
            if (!targetEl.length) return;

            // Stop the animation if the user scrolls manually
            page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
                page.stop();
            });

            var jumplinkHeight = jQuery(".jumplinks").is(":visible") ? jQuery(".jumplinks").outerHeight() : jQuery(".mobile-jumplinks").outerHeight();
            // If the jumplink isn't sticking, then don't offset by its height.
            if (jQuery(".jumplinks-nav").offset().top == jQuery(document).scrollTop())
                jumplinkHeight = 0;

            page.animate({
                scrollTop: targetEl.offset().top - jumplinkHeight
            }, "slow",
                function () {
                    page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                }
            );

            return false;
        });

        var jumplinkscrollTimer = undefined;
        var $mobileJumplink = jQuery(".mobile-jumplinks button");
        var defaultJumpBtnMobileText = $mobileJumplink.text();

        // add "active" class to the current visible section
        window.addEventListener("scroll", function (event) {
            clearTimeout(jumplinkscrollTimer);
            jumplinkscrollTimer = setTimeout(function () {
                var isMobile = jQuery(".mobile-jumplinks").is(":visible");

                var jumplinkHeight = isMobile ? jQuery(".mobile-jumplinks").outerHeight() : jQuery(".jumplinks").outerHeight();
                var fromTop = window.scrollY + jumplinkHeight + 20;
                var isBottom = ($(window).scrollTop() + $(window).height() == $(document).height());

                var showDefaultText = true;

                $jumplinks.toArray().forEach(function (link, index) {
                    var section = document.querySelector(link.hash);
                    var isLast = index == $jumplinks.length - 1;

                    // if you can't scroll to the bottom, also make the last item active
                    if (
                        (section.offsetTop <= fromTop || isBottom && isLast) &&
                        section.offsetTop + section.offsetHeight > fromTop
                    ) {

                        if (isMobile) {
                            $mobileJumplink.text(link.textContent.trim());
                            showDefaultText = false;
                        }

                        link.classList.add("active");

                    } else {
                        link.classList.remove("active");
                    }
                });

                if (showDefaultText) {
                    //$mobileJumplink.text(defaultJumpBtnMobileText);
                }
            }, 200);
        });
    }

    jQuery('#mobileJumplinkMenuButton').click(function () {
        jQuery(this).siblings('.dropdown-menu').toggle();
    });
    jQuery('.mobile-jumplinks a').click(function () {
        jQuery(this).parents('.dropdown-menu').hide();
    });
    jQuery('body').on('click', function (event) {
        if (!jQuery(event.target).is('#mobileJumplinkMenuButton')) {
            jQuery(".mobile-jumplinks .dropdown-menu").hide();
        }
    });

    // Observe the jumplink to determine when it becomes sticky.
    const el = document.querySelector(".jumplinks-nav");
    if (el && el.length > 1) {
        const jumplinksObserver = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
            { threshold: [1] }
        );
        jumplinksObserver.observe(el);
    }
})(jQuery);